export default function ByteArrayOutputStream() {}